import { Observable, catchError, map, throwError } from 'rxjs';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { HelpConfig } from '../config/help-config';
import { TokenService } from '../services/outros/token.service';
import { Token } from '../outros/token.model';
import { GuideStorageService } from '../../shared/guide/guide-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient, 
    private router: Router, 
    private tokenService: TokenService,
    private helpConfig: HelpConfig) { }

  public login(payload:{username: string, password: string}): Observable<unknown>{
    return this.http.post<{access_token:string}>( this.helpConfig.BASE_API + 'auth', payload).pipe(
      map((res)=>{
        localStorage.removeItem("access_token");
        localStorage.setItem("access_token", JSON.stringify(res.access_token))
       return this.router.navigate(['dashboard']);
      }),
      catchError((e: HttpErrorResponse)=>{
        if(e.error.message) return throwError(()=> e.error.message);
        return  throwError(()=>"Não estamos conseguindo validar estes dados, tente novamente mais tarde");
      })
    )
  }

  refreshToken(): Observable<Token> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    }
    const refreshToken = JSON.stringify(this.tokenService.getToken().refresh_token)
    return this.http.post<Token>(`${this.helpConfig.BASE_API}auth/refreshtoken`, refreshToken, httpOptions)
  }

  public logout(): void {
    GuideStorageService.preserveDuring(() => {
      localStorage.clear();
    });
    this.router.navigate(['']);
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('access_token');

    if(!token) return false;

    const jwtHelper = new JwtHelperService();

    return !jwtHelper.isTokenExpired(token);
  }
}